<script setup lang="ts">
import type {
  PeekPriceModalFerryPlusHotelItinerary,
  PeekPriceModalFlightPlusHotelItinerary,
} from '../../models';

import PeekPriceMediumBookableTransportCard from './PeekPriceMediumBookableTransportCard.vue';
import PeekPriceMediumHotelCard from './PeekPriceMediumHotelCard.vue';

interface PeekPriceBookableTransportPlusHotelProps {
  itinerary:
    | PeekPriceModalFlightPlusHotelItinerary
    | PeekPriceModalFerryPlusHotelItinerary;
}

const props = defineProps<PeekPriceBookableTransportPlusHotelProps>();
</script>

<template>
  <div class="peek-price-bookable-transport-plus-hotel">
    <PeekPriceMediumBookableTransportCard
      :data="itinerary.departureTransport"
      class="product-card"
    />
    <PeekPriceMediumHotelCard
      :data="props.itinerary.hotel"
      class="product-card"
    />
    <PeekPriceMediumBookableTransportCard
      :data="props.itinerary.arrivalTransport"
    />
  </div>
</template>

<style scoped lang="scss">
.peek-price-bookable-transport-plus-hotel {
  .product-card {
    padding-bottom: var(--spacing-16);
    margin-bottom: var(--spacing-16);
    border-bottom: 1px solid var(--color-neutral-20);
  }
}
</style>
